import React from 'react';
import './Modal.css';

export const Modal = ({ isOpen, onClose, title, children, primaryButtonText, primaryButtonAction, secondaryButtonText, secondaryButtonAction }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>{title}</h2>
          <button onClick={onClose} className="modal-close-btn">×</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
        <div className="modal-footer">
          {secondaryButtonText && (
            <button
              className="btn btn-outline"
              onClick={secondaryButtonAction || onClose}
            >
              {secondaryButtonText}
            </button>
          )}
          {primaryButtonText && (
            <button 
              className="btn btn-primary"
              onClick={primaryButtonAction}
            >
              {primaryButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};